import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  LineChart, Line, XAxis, Tooltip, CartesianGrid, ResponsiveContainer, ReferenceLine
} from "recharts";
import arrow from "../assets/arrow-up-right-svgrepo-com (1).svg";

const SalesTargetSalesChart = () => {
  const [currentSales] = useState(237532444);

  // ✅ جلب الهدف من localStorage أو قيمة افتراضية
  const [targetSales, setTargetSales] = useState(() => {
    return Number(localStorage.getItem("targetSales")) || 500000000;
  });

  const [isEditing, setIsEditing] = useState(false);
  const [tempTarget, setTempTarget] = useState(targetSales);

  const progress = (currentSales / targetSales) * 100;

  const data = [
    { month: "Jan", avgValue: 12000, avgItem: 15000 },
    { month: "Feb", avgValue: 18000, avgItem: 17000 },
    { month: "Mar", avgValue: 16000, avgItem: 19000 },
    { month: "Apr", avgValue: 20000, avgItem: 22000 },
    { month: "May", avgValue: 25000, avgItem: 23000 },
    { month: "Jun", avgValue: 27000, avgItem: 26000 },
    { month: "Jul", avgValue: 30000, avgItem: 31000 },
    { month: "Aug", avgValue: 28000, avgItem: 29000 },
    { month: "Sep", avgValue: 24000, avgItem: 25000 },
    { month: "Oct", avgValue: 22000, avgItem: 24000 },
    { month: "Nov", avgValue: 21000, avgItem: 23000 },
    { month: "Dec", avgValue: 26000, avgItem: 27000 },
  ];

  // ✅ تحديث localStorage عند تغيير الهدف
  useEffect(() => {
    localStorage.setItem("targetSales", targetSales);
  }, [targetSales]);

  const handleSave = () => {
    setTargetSales(tempTarget);
    setIsEditing(false);
  };

  return (
    <>
    <div className="flex flex-col flex-1 gap-6 pb-2">
      <div className="bg-white p-4 rounded-[24px] w-full min-w-[350px] shadow-md max-h-[180px] relative dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D]">
        <h3 className="text-[16px] mb-2 font-bold text-gray-700 dark:text-gray-200">Sales Target</h3>

        {/* Current & Target Sales */}
        <div className="flex flex-row justify-between items-start md:items-center mb-4">
          <div className=" text-gray-700">
            <span className="block text-sm text-gray-500 mb-1 dark:text-gray-400">In Progress</span>
            <span className="text-md font-semibold dark:text-gray-200">${currentSales.toLocaleString()}</span>
          </div>

          <div className="mb-2 text-gray-700">
            <div className="flex justify-between items-center gap-4">
            <span className="block text-sm text-gray-500 mb-1 dark:text-gray-400">Target Sales</span>
                    {/* زرار Edit/Save */}
        <div className="flex gap-2 ">
          {!isEditing ? (
            <button
              onClick={() => setIsEditing(true)}
              className="px-2 py-1 text-xs border rounded-lg bg-white text-gray-500 dark:bg-[#1A1A1B] dark:text-gray-400"
            >
              Edit
            </button>
          ) : (
            <div className="flex gap-2">
              <button
                onClick={handleSave}
                className="px-2 py-1 text-xs border rounded-lg agarly-btn-primary text-agarly-dark"
              >
                Save
              </button>
              <button
                onClick={() => {
                  setTempTarget(targetSales); 
                  setIsEditing(false);
                }}
                className="px-2 py-1 text-xs border rounded-lg text-gray-600 dark:text-gray-400"
              >
                Cancel
              </button>
            </div>
          )}
        </div>
        </div>
            {!isEditing ? (
              <span className="text-md font-semibold dark:text-gray-200">
                ${targetSales.toLocaleString()}
              </span>
            ) : (
              <input
                type="number"
                value={tempTarget}
                onChange={(e) => setTempTarget(Number(e.target.value))}
                className="border rounded px-2 py-1 w-full mt-2 dark:bg-[#2D2D2D] dark:text-gray-300"
              />
            )}
          </div>
        </div>



        {/* Glowing progress bar */}
        <div className="relative w-full h-7 bg-gray-100 rounded-lg overflow-hidden mb-2 dark:bg-[#2D2D2D]">
          <div
            style={{ width: `${progress}%` }}
            className="h-full bg-gradient-to-r from-[#5DEBFF] via-[#7CC9FF] to-[#5DEBFF] rounded-lg relative overflow-hidden"
          >
            <div className="absolute top-0 left-[-5rem] w-20 h-full bg-white opacity-80 blur-lg animate-glowLight"></div>
          </div>
        </div>
        <style>{`
          @keyframes glowLight {
            0% { left: -5rem; }
            100% { left: 100%; }
          }
          .animate-glowLight {
            animation: glowLight 2.5s linear infinite;
          }
        `}</style>
      </div>

        {/* Sales chart section */}
        <div className="flex flex-1 flex-wrap min-w-[350px] gap-6 w-full">
          <div className="bg-white p-4 rounded-[24px] shadow-md flex-1 
            dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D]">
            
            <div className="flex justify-between items-start mb-2">
              <div>
                <h2 className="text-[16px] font-semibold text-gray-800 dark:text-gray-200">
                  Your Sales this year
                </h2>
                <div className="flex flex-wrap items-center gap-4 text-[14px] text-gray-500 dark:text-gray-400 mt-1">
                  <div className="flex items-center gap-1">
                    <span className="w-3 h-3 rounded-full bg-[#7CC9FF]"></span> Average Sale Value
                  </div>
                  <div className="flex items-center gap-1">
                    <span className="w-3 h-3 rounded-full bg-[#1a71f6]"></span> Average item per sale
                  </div>
                </div>
              </div>
              <Link 
                to="/sales" 
                className="flex text-[14px] w-[100px] text-gray-600 dark:text-gray-300 hover:underline"
              >
                Show All <img src={arrow} alt="" className="w-5 h-5" />
              </Link>
            </div>

            <div className="flex gap-4 mb-4 flex justify-center items-center">
              <div className="border-2 max-w-[140px] border-dashed border-[#1a71f6] 
                px-1 py-1 rounded-xl text-center flex-1
                bg-white dark:bg-[#2A2A2B]"
              >
                <div className="text-[10px] text-gray-500 dark:text-gray-400">
                  Average item per sale
                </div>
                <div className="font-bold text-[14px] text-[#454545] dark:text-gray-200">
                  $211,411,223
                </div>
              </div>
              <div className="bg-[#7CC9FF] max-w-[130px] text-white px-1 py-1 rounded-xl text-center flex-1 
                dark:bg-[#7CC9FF] "
              >
                <div className="text-[10px] text-gray-500 dark:text-gray-800">
                  Average year on year
                </div>
                <div className="font-bold text-[14px] text-[#454545] dark:text-gray-500">
                  $339,091,888
                </div>
              </div>
            </div>

            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={data}>
                <CartesianGrid 
                  stroke="#eee" 
                  strokeDasharray="3 3" 
                  className="dark:stroke-gray-700"
                />
                <XAxis
                  dataKey="month"
                  interval={0}
                  tick={{ fontSize: 11, fill: "var(--tw-prose-body, #6B7280)" }}
                  padding={{ left: 20, right: 20 }}
                />
                <Tooltip 
                  contentStyle={{ 
                    backgroundColor: "#777777ff", 
                    border: "1px solid #3D3D3D", 
                    color: "#E5E7EB" 
                  }} 
                  wrapperStyle={{ outline: "none" }}
                />
                <ReferenceLine x="Jul" stroke="rgba(62, 113, 214, 0.8)" strokeWidth={2} />
                <Line
                  type="monotone"
                  dataKey="avgItem"
                  stroke="#5DEBFF"
                  strokeWidth={3}
                  strokeDasharray="7 7"
                  dot={false}
                  isAnimationActive={true}
                  animationDuration={1500}
                />
                <Line
                  type="monotone"
                  dataKey="avgValue"
                  stroke="#7CC9FF"
                  strokeWidth={3}
                  dot={false}
                  isAnimationActive={true}
                  animationDuration={1500}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

      </div>
    </>
  );
};

export default SalesTargetSalesChart;
